import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { SCORE_RANKS } from '../game/gameConfig';

const { FiExternalLink, FiRefreshCw, FiTarget, FiZap, FiAward } = FiIcons;

function ResultScreen({ result, bestScore, onRestart }) {
  return (
    <main className="result-screen">
      <motion.section
        className="result-card"
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
      >
        <span className="eyebrow">大灣區詠春家文化廣場 2026 · 10.03</span>
        <SafeIcon icon={FiAward} className="result-award" />
        <h1>{result.title}</h1>

        <div className="total-score">
          <small>總得分</small>
          <strong>{result.score.toLocaleString()}</strong>
          <span>個人最佳：{bestScore.toLocaleString()}</span>
        </div>

        <div className="result-stats">
          <div>
            <SafeIcon icon={FiTarget} />
            <strong>{result.accuracy}%</strong>
            <span>體驗完成度</span>
          </div>
          <div>
            <SafeIcon icon={FiZap} />
            <strong>{result.bestCombo}</strong>
            <span>最長同步</span>
          </div>
          <div>
            <SafeIcon icon={FiAward} />
            <strong>{result.finalHits}</strong>
            <span>日字衝拳</span>
          </div>
        </div>

        <div className="result-actions">
          <a
            className="primary-button"
            href="https://mpesport.com/"
            target="_blank"
            rel="noreferrer"
          >
            查看活動詳情
            <SafeIcon icon={FiExternalLink} />
          </a>
          <button className="secondary-button" type="button" onClick={onRestart}>
            <SafeIcon icon={FiRefreshCw} />
            再玩一次
          </button>
        </div>

        <section className="rank-board" aria-labelledby="rank-board-title">
          <h2 id="rank-board-title">詠春挑戰級別</h2>
          <div className="rank-table-wrap">
            <table>
              <thead>
                <tr>
                  <th>級別</th>
                  <th>稱號</th>
                  <th>所需分數</th>
                </tr>
              </thead>
              <tbody>
                {SCORE_RANKS.map((rank) => (
                  <tr
                    className={result.title === rank.title ? 'is-current-rank' : ''}
                    key={rank.title}
                  >
                    <td>{rank.level}</td>
                    <td>{rank.title}</td>
                    <td>{rank.range}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>

        <p className="result-message">
          10 月 3 日，相約大灣區詠春家文化廣場 2026，親身投入詠春千人匯演及詠春嘉年華。
        </p>
      </motion.section>
    </main>
  );
}

export default ResultScreen;